<template lang="html">
  <nav class="li flex">
    <div class="sli lundi uc ls">
      <router-link :to="{ name: 'home' }">Lundi Piscine</router-link>
    </div>
    <div class="sli f-1 no-mobile"></div>
    <div v-for="item in nav" :key="item.uid" class="sli">
      <router-link v-if="item.template == 'collections'" class="lundi" :to="{ name: 'collections', params: { collection: item.uid } }">{{ item.title }}</router-link>
      <router-link v-else class="lundi" :to="{ name: item.uid }">{{ item.title }}</router-link>
    </div>
    <div
      v-if="cartNumber > 0"
      class="nav-cart lundi sli flex link"
      @click="toggleCart"
    >
      <div class="cart-count">
        {{ cartNumber }}
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  methods: {
    toggleCart() {
      this.$root.$emit("toggleCart");
    }
  },
  computed: {
      nav() {
            return this.$store.state.site.nav;
      },
      cartNumber() {
            return this.$store.state.shop.cart.length;
      }
  }
};
</script>

<style lang="scss" scoped>
nav {
  position: fixed !important;
  background: white;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  margin: 0;
  .cart-count {
    display: inline-block;
    border-radius: 50%;
    font-size: calc(0.75 * var(--fs));
    width: var(--lh);
    text-align: center;
    vertical-align: bottom;
    color: white;
    background: var(--orange);
  }
}
</style>
